const SHOW_ERROR = 'AFTERPAY_SHOW_ERROR';
const RESET_ERROR = 'AFTERPAY_RESET_ERROR';
const TOGGLE_SELECTED = 'AFTERPAY_TOGGLE_SELECTED';
const SET_READY = 'AFTERPAY_SET_READY';

export {
    SHOW_ERROR, RESET_ERROR, TOGGLE_SELECTED, SET_READY
};
